import { IndeterminateProgress } from '../../progress';
import { ToastVariantType } from '../toastType';

export const getToastIcon = (variant: ToastVariantType) => {
  switch (variant) {
    case 'enabled':
      return null;
    case 'success':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.2676 8.28967C18.7163 8.70095 18.7466 9.39806 18.3353 9.84672L12.2211 16.5168C11.7736 17.005 11.0093 17.0216 10.541 16.5533L6.94778 12.96C6.51741 12.5296 6.51741 11.8319 6.94778 11.4015C7.37815 10.9711 8.07593 10.9711 8.5063 11.4015L11.3309 14.2261L16.7106 8.35737C17.1219 7.90871 17.819 7.8784 18.2676 8.28967Z"
            fill="#14B866"
          />
        </svg>
      );
    case 'warning':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.8746 2.09961C7.40699 2.09961 2.97461 6.53199 2.97461 11.9996C2.97461 17.4672 7.40699 21.8996 12.8746 21.8996C18.3422 21.8996 22.7746 17.4672 22.7746 11.9996C22.7746 6.53199 18.3422 2.09961 12.8746 2.09961ZM11.6056 7.65043C11.5302 6.89697 12.1219 6.24316 12.8791 6.24316C13.6364 6.24316 14.228 6.89697 14.1527 7.65043L13.6566 12.2964C13.6167 12.6958 13.2806 13 12.8791 13C12.4777 13 12.1416 12.6958 12.1016 12.2964L11.6056 7.65043ZM11.4648 16.1432C11.4648 15.3621 12.098 14.7289 12.8791 14.7289C13.6602 14.7289 14.2934 15.3621 14.2934 16.1432C14.2934 16.9243 13.6602 17.5574 12.8791 17.5574C12.098 17.5574 11.4648 16.9243 11.4648 16.1432Z"
            fill="#FF7C0A"
          />
        </svg>
      );
    case 'loading':
      return <IndeterminateProgress color={'inverse'} size={24} />;
  }
};
